import apiClient from "./axiosInstance"

export const TAgetQuizzes = async (language: string) => {
  const response = await apiClient.get(`/admin/quiz/quizzes?language=${language}`, {})
  if (response.status === 200) {
    return response.data
  } else {
    throw new Error("Find User failed")
  }
}
